/**
 * Permet de transformer les donn�es du widget vers l'API ou inversement
 */
import {ENTITY_TYPES} from "../lib/constants";

export class DataHelper {

    static rowFromWidgetToAPI(row) {
        return {
            ...row,
            ...row.transformationMatrix,
            roomId: 1,
            sequence: row.indexingMethod || 1,
            sequenceOffset: row.startIndex || 1,
            sequenceDirection: '+'
        }
    }

    static rowFromAPIToWidget(row, categories = null) {
        const {
            a, b, c, d, e, f,
            sequence,
            sequenceOffset
        } = row;

        if (!row.categoryId) {
            row.category = null
        } else if (categories) {
            row.category = categories.filter(category => parseInt(category.id) === parseInt(row.categoryId))[0];
        }

        row.transformationMatrix = { a, b, c, d, e, f };
        row.type = ENTITY_TYPES.ROW;
        row.indexingMethod = sequence;
        row.startIndex = sequenceOffset;
        Object.keys(row.transformationMatrix).forEach(key => {
            row.transformationMatrix[key] = parseFloat(row.transformationMatrix[key]);
        });

        return row
    }

    static pitFromAPIToWidget(pit, categories = null) {
        const {
            a, b, c, d, e, f
        } = pit;

        if (!pit.categoryId) {
            pit.category = null
        } else if (categories) {
            pit.category = categories.filter(category => parseInt(category.id) === parseInt(pit.categoryId))[0];
        }

        pit.transformationMatrix = { a, b, c, d, e, f };
        pit.type = ENTITY_TYPES.PIT;
        Object.keys(pit.transformationMatrix).forEach(key => {
            pit.transformationMatrix[key] = parseFloat(pit.transformationMatrix[key]);
        });

        return pit
    }

    static imageFromAPIToWidget(image) {
        if (image.a) {
            const { a, b, c, d, e, f } = image;
            image.transformationMatrix = { a, b, c, d, e, f };
            Object.keys(image.transformationMatrix).forEach(key => {
                image.transformationMatrix[key] = parseFloat(image.transformationMatrix[key]);
            });
        } else {
            image.transformationMatrix = null;
        }

        image.type = ENTITY_TYPES.IMAGE;

        return image
    }

    static textFromWidgetToAPI(text) {
        return {
            ...text,
            ...text.transformationMatrix,
            height: text.fontSize
        };
    }

    static textFromAPIToWidget(text, descriptions = []) {
        const { a, b, c, d, e, f } = text;

        const descr = descriptions.find(description => description.id === text.descriptionId);

        text.transformationMatrix = { a, b, c, d, e, f };
        text.type = "TEXT";
        text.fontSize = parseInt(text.fontSize) ? parseInt(text.fontSize) : 30;
        text.description = descr ? {...descr, label: descr.text} : null;

        Object.keys(text.transformationMatrix).forEach(key => {
            text.transformationMatrix[key] = parseFloat(text.transformationMatrix[key]);
        });

        return text
    }
}